var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

// src/utils/body-lock.js
var bodyLock = class {
  /**
   * lock the body to prevent scrolling.
   */
  lock() {
    const bodyElement = document.querySelector("body");
    bodyElement.classList.add("js-scroll-lock");
  }
  /**
   * unlock the scrolling of the body.
   */
  unlock() {
    const bodyElement = document.querySelector("body");
    bodyElement.classList.remove("js-scroll-lock");
  }
};
var body_lock_default = new bodyLock();

// src/utils/get-sections.js
var getCartSectionsToRender = () => {
  var _a, _b, _c, _d, _e, _f;
  return [
    {
      id: "cart-items",
      section: (_a = document.getElementById("cart-items")) == null ? void 0 : _a.dataset.id,
      selector: "#cart-items"
    },
    {
      id: "cart-promo-meter",
      section: (_b = document.getElementById("cart-items")) == null ? void 0 : _b.dataset.id,
      selector: "#cart-promo-meter"
    },
    {
      id: "cart-buy-get-text",
      section: (_c = document.getElementById("cart-items")) == null ? void 0 : _c.dataset.id,
      selector: "#cart-buy-get-text"
    },
    {
      id: "cart-gift-wrapping",
      section: (_d = document.getElementById("cart-items")) == null ? void 0 : _d.dataset.id,
      selector: "#cart-gift-wrapping"
    },
    {
      id: "cart-cards",
      section: (_e = document.getElementById("cart-items")) == null ? void 0 : _e.dataset.id,
      selector: "#cart-cards"
    },
    {
      id: "cart-item-counter",
      section: "cart-item-counter",
      selector: "#cart-item-counter"
    },
    {
      id: "cart-summary",
      section: (_f = document.querySelector(".cart-drawer__summary")) == null ? void 0 : _f.dataset.sectionId,
      selector: "#cart-summary"
    },
    {
      id: "related-products-cart",
      section: "related-products-cart",
      selector: "#related-products-cart"
    }
  ];
};

// src/utils/meta-theme.js
var metaThemeColorElement = document.querySelector("meta[name=theme-color]");
var MetaThemeColor = class {
  /**
   * Set modal color as the theme color.
   */
  setModalColor() {
    const themeColor = "#fff";
    metaThemeColorElement.setAttribute("content", themeColor);
  }
  /**
   * Set modal color as the theme color.
   */
  setAnnouncementBarColor() {
    const themeColor = "#242424";
    metaThemeColorElement.setAttribute("content", themeColor);
  }
  /**
   * Set default color as the theme color.
   */
  setDefaultColor() {
    const announcementBarElement = document.querySelector('announcement-bar[data-role="announcement-bar"]');
    const color = "#fff";
    if (announcementBarElement.classList.contains("js-window-scrolled")) {
      metaThemeColorElement.setAttribute("content", color);
    } else {
      this.setAnnouncementBarColor();
    }
  }
  /**
   * Set custom color as theme color.
   * 
   * @param {string} color 
   */
  setCustomColor(color) {
    metaThemeColorElement.setAttribute("content", color);
  }
};
var meta_theme_default = new MetaThemeColor();

// src/utils/debounce.js
var debounce = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(void 0, args);
    }, timeout);
  };
};

// src/extenders/surf-modal.js
var _hideOnClickOutside, hideOnClickOutside_fn, _addCloseEventListener, addCloseEventListener_fn, _getCorrectModalByAriaControls, getCorrectModalByAriaControls_fn;
var SurfModal = class {
  constructor() {
    __privateAdd(this, _hideOnClickOutside);
    /**
     * Add close event listener
     */
    __privateAdd(this, _addCloseEventListener);
    /**
     * Get correct modal by target id
     *
     * @param {string} ariaControls
     *
     * @returns {element}
     */
    __privateAdd(this, _getCorrectModalByAriaControls);
    /**
     * Send variant image update event.
     */
    __publicField(this, "sendUpdateModalState", debounce((state, ariaControls, triggerElement, deeplinkTarget) => {
      const event = new CustomEvent("modal-state", {
        detail: {
          state,
          ariaControls: `${ariaControls}`,
          deeplinkTarget: `${deeplinkTarget || null}`,
          element: triggerElement ? triggerElement : null
        }
      });
      document.dispatchEvent(event);
    }, 100));
  }
  /**
   * Open modal.
   * 
   * @param {string} ariaControls 
   * @param {HTMLElement} triggerElement 
   * @param {string} deeplinkTarget optional
   */
  openModal(ariaControls, triggerElement, deeplinkTarget) {
    const modal = __privateMethod(this, _getCorrectModalByAriaControls, getCorrectModalByAriaControls_fn).call(this, ariaControls);
    const allSameAriaControlsElements = document.querySelectorAll(`button[aria-controls="${ariaControls}"]`);
    if (modal) {
      const allActiveItemsInsideModal = modal.querySelectorAll(".js-active");
      modal.classList.remove("initial-load");
      modal.classList.add("js-modal-open");
      if (ariaControls == "cart-drawer") {
        const metaThemeColorElement2 = document.querySelector("meta[name=theme-color]");
        const announcementBarElement = document.querySelector(".announcement-bar");
        const announcementBarHeight = announcementBarElement.offsetHeight;
        const offset = announcementBarHeight * 3;
        const scrollPosition = window.scrollY;
        if (scrollPosition > offset) {
          const themeColor = "#FFFFFF";
          metaThemeColorElement2.setAttribute("content", themeColor);
        } else {
          const themeColor = "#FFFFFF";
          metaThemeColorElement2.setAttribute("content", themeColor);
        }
      }
      if (allActiveItemsInsideModal.length > 0) {
        allActiveItemsInsideModal.forEach((activeItemElement) => {
          activeItemElement.classList.remove("js-active");
        });
      }
      if (deeplinkTarget) {
        const deeplinkTargetElement = modal.querySelector(`#${deeplinkTarget}`);
        if (deeplinkTargetElement) {
          deeplinkTargetElement.classList.add("js-active");
        }
      }
      __privateMethod(this, _addCloseEventListener, addCloseEventListener_fn).call(this, modal, ariaControls);
      __privateMethod(this, _hideOnClickOutside, hideOnClickOutside_fn).call(this, modal, ariaControls);
      body_lock_default.lock();
      this.sendUpdateModalState("open", ariaControls, triggerElement, deeplinkTarget);
    }
    allSameAriaControlsElements.forEach((ariaElement) => {
      ariaElement.ariaExpanded = "true";
    });
  }
  /**
   * Close modal 
   * @param {string} ariaControls 
   */
  closeModal(ariaControls) {
    const modal = __privateMethod(this, _getCorrectModalByAriaControls, getCorrectModalByAriaControls_fn).call(this, ariaControls);
    const allSameAriaControlsElements = document.querySelectorAll(`button[aria-controls="${ariaControls}"]`);
    if (modal) {
      modal.classList.remove("js-modal-open");
      body_lock_default.unlock();
      this.sendUpdateModalState("close", ariaControls);
    }
    allSameAriaControlsElements == null ? void 0 : allSameAriaControlsElements.forEach((ariaElement) => {
      ariaElement.ariaExpanded = "false";
    });
  }
  /**
   * Open modal.
   * 
   * @param {string} ariaControls 
   * @param {HTMLElement} triggerElement 
   * @param {string} deeplinkTarget optional
   */
  handleModalState(ariaControls, triggerElement, deeplinkTarget) {
    const ariaExpanded = triggerElement.getAttribute("aria-expanded");
    const metaThemeColorElement2 = document.querySelector("meta[name=theme-color]");
    if (ariaExpanded === "false") {
      meta_theme_default.setModalColor();
      if (ariaControls.includes("reviews-modal")) {
        metaThemeColorElement2.setAttribute("content", "#000000E5");
      }
      this.openModal(ariaControls, triggerElement, deeplinkTarget);
      const chevronIconElement = triggerElement.querySelector(".icon-chevron");
      if (chevronIconElement) {
        chevronIconElement.classList.add("js-open");
        chevronIconElement.classList.remove("js-closed");
      }
    } else {
      meta_theme_default.setDefaultColor();
      this.closeModal(ariaControls);
      const chevronIconElement = triggerElement.querySelector(".icon-chevron");
      if (chevronIconElement) {
        chevronIconElement.classList.remove("js-open");
        chevronIconElement.classList.add("js-closed");
      }
    }
  }
  /**
   * Get current state of the cart modal.
   *
   * @returns {{state: string, isCartOpen: boolean}}
   */
  getCurrentState(ariaControls) {
    const modal = __privateMethod(this, _getCorrectModalByAriaControls, getCorrectModalByAriaControls_fn).call(this, ariaControls);
    if (modal.classList.contains("js-modal-open")) {
      return {
        state: "open",
        isModalOpen: true
      };
    } else {
      return {
        state: "closed",
        isModalOpen: false
      };
    }
  }
};
_hideOnClickOutside = new WeakSet();
hideOnClickOutside_fn = function(modal, ariaControls) {
  const outsideClickListener = (event) => {
    var _a;
    const target = event.target;
    const allModalOpeners = document.querySelectorAll(".js-handle-modal");
    const arrayAllModalOpeners = [...allModalOpeners];
    const ariaControlValue = target.getAttribute("aria-labelledby");
    const allSameAriaControlsElements = document.querySelectorAll(`button[aria-controls="${ariaControls}"]`);
    if (target.classList.contains("modal-overlay")) {
      this.closeModal(ariaControls);
      removeClickListener();
      allSameAriaControlsElements.forEach((ariaElement) => {
        const chevronIconElement = ariaElement.querySelector(".icon-chevron");
        if (chevronIconElement) {
          chevronIconElement.classList.remove("js-open");
          chevronIconElement.classList.add("js-closed");
        }
        ariaElement.ariaExpanded = "false";
      });
    } else {
      if (target !== modal && target.closest(".modal") || ((_a = target.closest(".button")) == null ? void 0 : _a.classList.contains("js-no-close")) || arrayAllModalOpeners.filter(
        (modalOpener) => modalOpener === target.closest(".js-handle-modal")
      ).length !== 0) {
      } else {
        this.closeModal(ariaControls);
        removeClickListener();
        allSameAriaControlsElements.forEach((ariaElement) => {
          const chevronIconElement = ariaElement.querySelector(".icon-chevron");
          if (chevronIconElement) {
            chevronIconElement.classList.remove("js-open");
            chevronIconElement.classList.add("js-closed");
          }
          ariaElement.ariaExpanded = "false";
        });
      }
    }
  };
  const removeClickListener = () => {
    document.removeEventListener("click", outsideClickListener);
  };
  document.addEventListener("click", outsideClickListener);
};
_addCloseEventListener = new WeakSet();
addCloseEventListener_fn = function(modal, ariaControls) {
  const allCloseModalButtons = modal.querySelectorAll(".js-close-modal");
  const submitButton = modal.querySelector(".js-modal-submit");
  if (allCloseModalButtons) {
    allCloseModalButtons.forEach((closeModalButton2) => {
      const closeClick = () => {
        this.closeModal(ariaControls);
        removeClickListener();
      };
      const removeClickListener = () => {
        closeModalButton2.removeEventListener("click", closeClick);
      };
      closeModalButton2.addEventListener("click", () => {
        this.handleModalState(ariaControls, closeModalButton2);
      });
    });
  }
  if (submitButton) {
    const closeClick = () => {
      this.closeModal(ariaControls);
      removeClickListener();
    };
    const removeClickListener = () => {
      closeModalButton.removeEventListener("click", closeClick);
    };
    submitButton.addEventListener("click", closeClick);
  }
};
_getCorrectModalByAriaControls = new WeakSet();
getCorrectModalByAriaControls_fn = function(ariaControls) {
  const modalChild = document.querySelector(`[aria-labelledby="${ariaControls}"]`);
  const modalElement = modalChild ? modalChild.closest(".modal") : null;
  if (modalElement)
    return modalElement;
};
var surf_modal_default = SurfModal;

// src/utils/section-injection.js
var getSectionFromHTML = (html, selector) => {
  if (html) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }
};

// src/utils/cart.js
var handleChangeCart = (responseData) => {
  getCartSectionsToRender().forEach((section) => {
    const elementToReplace = document.querySelectorAll(section.selector) || document.getElementById(section.id).querySelector(section.selector);
    if (elementToReplace !== null) {
      elementToReplace.forEach((element) => {
        element.innerHTML = getSectionFromHTML(
          responseData.sections[section.section],
          section.selector
        );
      });
    }
  });
  const cardElement = document.querySelector(".cart-drawer__cart-cards");
  if (cardElement) {
    const allOpenModalButtonElements = cardElement.querySelectorAll(".js-handle-modal");
    const baseModal = new surf_modal_default();
    allOpenModalButtonElements.forEach((openModalButtonElement) => {
      const ariaControls = openModalButtonElement ? openModalButtonElement.getAttribute("aria-controls") : null;
      openModalButtonElement.addEventListener("click", () => {
        baseModal.handleModalState(ariaControls, openModalButtonElement);
      }, true, { passive: true });
    });
  }
};

// src/extenders/quick-add-modal.js
var QuickAddModal = class extends HTMLElement {
  /**
   * Creates an instance of QuickAddModal.
   * Initializes modal elements and sets up base functionality.
   */
  constructor() {
    super();
    this.modal = this;
    this.closeIcon = null;
    this.variants = null;
    this.boundEventHandlers = {
      handleOutsideClick: this.handleOutsideClick.bind(this),
      handleFormSubmit: this.handleFormSubmit.bind(this),
      handleCloseClick: this.close.bind(this)
    };
  }
  /**
   * Initializes the modal component by setting up event listeners.
   * @private
   */
  init() {
    this.initializeEventListeners();
  }
  /**
   * Opens the modal and loads product content dynamically.
   * Fetches product data, updates modal content, and displays the modal.
   * 
   * @async
   * @param {string} productUrl - The URL of the product to load
   * @returns {Promise<boolean>} Promise that resolves to true if modal opens successfully
   * @throws {Error} Throws error if product loading fails
   */
  async open(productUrl) {
    try {
      const sectionId = this.modal.getAttribute("data-section-id");
      if (!sectionId) {
        throw new Error("Missing data-section-id attribute on modal element");
      }
      const separator = productUrl.includes("?") ? "&" : "?";
      const productUrlWithSection = `${productUrl}${separator}section_id=${sectionId}`;
      const response = await fetch(productUrlWithSection);
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      const html = await response.text();
      const parsedHTML = new DOMParser().parseFromString(html, "text/html");
      const productDetails = parsedHTML.querySelector("#quick-add-modal");
      if (!productDetails) {
        throw new Error("Product details not found in response");
      }
      this.modal.innerHTML = productDetails.innerHTML;
      this.modal.setAttribute("aria-hidden", "false");
      body_lock_default.lock();
      this.initializeEventListeners();
      this.initializeVariantSelection();
      return true;
    } catch (error) {
      console.error("Error loading quick add modal:", error);
      throw error;
    }
  }
  /**
   * Closes the modal and unlocks body scroll.
   * Hides the modal and restores page scrolling.
   */
  close() {
    this.modal.setAttribute("aria-hidden", "true");
    body_lock_default.unlock();
  }
  /**
   * Handles clicks outside the modal content area to close the modal.
   * Only closes if the click is outside the modal content.
   * 
   * @param {Event} event - The click event
   */
  handleOutsideClick(event) {
    if (event.target === this.modal && !this.modal.closest(".quick-add-modal__content")) {
      this.close();
    }
  }
  /**
   * Initializes variant selection functionality.
   * Parses variant data, sets up option inputs, and handles variant updates.
   * @private
   */
  initializeVariantSelection() {
    const variantScript = this.modal.querySelector(".product-variants-data");
    if (variantScript) {
      try {
        this.variants = JSON.parse(variantScript.textContent);
      } catch (error) {
        console.error("Error parsing variant data:", error);
        this.variants = null;
      }
    }
    const variantInputs = this.modal.querySelectorAll('input[name^="options["]');
    variantInputs.forEach((input) => {
      input.addEventListener("change", () => {
        if (!input.disabled) {
          this.updateSelectedVariant();
        }
      });
    });
    const addButton = this.modal.querySelector(".button--primary");
    if (addButton && !addButton.getAttribute("data-original-text")) {
      addButton.setAttribute("data-original-text", addButton.textContent);
    }
    this.updateSelectedVariant();
  }
  /**
   * Updates the selected variant based on current option selections.
   * Finds matching available variant and updates the variant ID input.
   * @private
   */
  updateSelectedVariant() {
    if (!this.variants)
      return;
    const selectedOptions = this.getSelectedOptions();
    const selectedVariant = this.findMatchingVariant(selectedOptions);
    if (selectedVariant) {
      const variantIdInput = this.modal.querySelector(".product-variant-id");
      if (variantIdInput) {
        variantIdInput.value = selectedVariant.id;
      }
    }
  }
  /**
   * Gets currently selected options from the variant inputs.
   * 
   * @private
   * @returns {Object} Object containing selected option names and values
   */
  getSelectedOptions() {
    const selectedOptions = {};
    const optionInputs = this.modal.querySelectorAll('input[name^="options["]:checked:not([disabled])');
    optionInputs.forEach((input) => {
      const match = input.name.match(/options\[(.+)\]/);
      if (match) {
        const optionName = match[1];
        selectedOptions[optionName] = input.value;
      }
    });
    return selectedOptions;
  }
  /**
   * Finds a variant that matches the selected options and is available.
   * 
   * @private
   * @param {Object} selectedOptions - The currently selected option values
   * @returns {Object|null} The matching variant or null if none found
   */
  findMatchingVariant(selectedOptions) {
    return this.variants.find((variant) => {
      return this.matchesSelectedOptions(variant, selectedOptions) && variant.available;
    });
  }
  /**
   * Checks if a variant matches the selected options.
   * Compares variant options against selected values.
   * 
   * @private
   * @param {Object} variant - The variant to check
   * @param {Object} selectedOptions - The selected option values
   * @returns {boolean} True if variant matches selected options
   */
  matchesSelectedOptions(variant, selectedOptions) {
    const optionNames = Object.keys(selectedOptions);
    return optionNames.every((optionName) => {
      const selectedValue = selectedOptions[optionName];
      return variant.option1 === selectedValue || variant.option2 === selectedValue || variant.option3 === selectedValue;
    });
  }
  /**
   * Initializes all event listeners for the modal.
   * Sets up close button, outside click, and form submission handlers.
   * @private
   */
  initializeEventListeners() {
    this.closeIcon = this.modal.querySelector("#quick-add-modal-close");
    if (this.closeIcon) {
      this.closeIcon.addEventListener("click", this.boundEventHandlers.handleCloseClick);
    }
    this.modal.addEventListener("click", this.boundEventHandlers.handleOutsideClick);
    const form = this.modal.querySelector("form");
    if (form) {
      form.addEventListener("submit", this.boundEventHandlers.handleFormSubmit);
    }
  }
  /**
   * Cleans up event listeners to prevent memory leaks.
   * Removes existing event listeners before re-initialization.
   * @private
   */
  cleanupEventListeners() {
    if (this.closeIcon) {
      this.closeIcon.removeEventListener("click", this.boundEventHandlers.handleCloseClick);
    }
    this.modal.removeEventListener("click", this.boundEventHandlers.handleOutsideClick);
  }
  /**
   * Handles form submission to add product to cart.
   * Processes the add to cart request, updates UI, and handles success/error states.
   * 
   * @async
   * @param {Event} event - The form submission event
   * @private
   */
  async handleFormSubmit(event) {
    event.preventDefault();
    const form = event.target;
    const addButton = form.querySelector(".button--primary");
    const addedMessage = this.modal.querySelector(".item-added-message");
    const originalText = (addButton == null ? void 0 : addButton.textContent) || "";
    if (addButton) {
      addButton.disabled = true;
      addButton.textContent = window.translations.adding;
    }
    try {
      const formData = new FormData(form);
      const variantId = formData.get("id");
      if (!variantId) {
        throw new Error("No variant selected");
      }
      const requestBody = this.buildCartAddRequest(variantId);
      const response = await this.addToCart(requestBody);
      if (response.ok) {
        const result = await response.json();
        await this.handleAddToCartSuccess(result);
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to add product to cart");
      }
    } catch (error) {
      console.error("Error adding product to cart:", error);
      this.handleAddToCartError(error, addedMessage);
    } finally {
      if (addButton) {
        addButton.disabled = false;
        addButton.textContent = originalText;
      }
    }
  }
  /**
   * Builds the request body for adding item to cart.
   * 
   * @private
   * @param {string} variantId - The variant ID to add to cart
   * @returns {string} JSON string for the request body
   */
  buildCartAddRequest(variantId) {
    return JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: getCartSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
  }
  /**
   * Makes the API request to add item to cart.
   * 
   * @private
   * @param {string} requestBody - The JSON request body
   * @returns {Promise<Response>} The fetch response
   */
  async addToCart(requestBody) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: requestBody
    });
  }
  /**
   * Handles successful add to cart response.
   * Updates UI elements and sets up cart drawer functionality.
   * 
   * @private
   * @param {Object} result - The cart add response data
   */
  async handleAddToCartSuccess(result) {
    const addedMessage = this.modal.querySelector(".item-added-message");
    if (addedMessage) {
      addedMessage.style.display = "flex";
    }
    const successButtons = this.modal.querySelector(".quick-add-modal__success-buttons");
    const addToCartButton = this.modal.querySelector(".add-to-cart-button");
    if (successButtons) {
      successButtons.style.display = "flex";
    }
    if (addToCartButton) {
      addToCartButton.style.display = "none";
    }
    this.setupCartDrawerButton();
    handleChangeCart(result);
    document.dispatchEvent(
      new CustomEvent("cart:updated", {
        detail: result
      })
    );
  }
  /**
   * Sets up the cart drawer button functionality.
   * Adds event listener to open cart drawer and close modal.
   * @private
   */
  setupCartDrawerButton() {
    const cartButton = this.modal.querySelector("#open-cart-drawer");
    if (cartButton) {
      const newCartButton = cartButton.cloneNode(true);
      cartButton.parentNode.replaceChild(newCartButton, cartButton);
      newCartButton.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const headerCartButton = document.querySelector('.js-handle-modal[aria-controls="cart-drawer"]');
        if (headerCartButton) {
          headerCartButton.click();
        } else {
          const cartDrawer = new surf_modal_default();
          cartDrawer.openModal("cart-drawer", null);
        }
        setTimeout(() => {
          this.close();
        }, 200);
      });
    }
  }
  /**
   * Cleanup method called when element is removed from DOM.
   * Removes event listeners and unlocks body if modal is open.
   */
  disconnectedCallback() {
    this.cleanupEventListeners();
    if (this.modal.getAttribute("aria-hidden") === "false") {
      body_lock_default.unlock();
    }
    this.init();
  }
};
if (customElements.get("quick-add-modal") === void 0) {
  customElements.define("quick-add-modal", QuickAddModal);
}
